<template>
  <div :class="$style.wrap">
    <div :class="$style.intro">
      <h1 :class="$style.headline">The Scrub Hare Crate's Project</h1>
      <h2>CALL +264 81 395 5286 TO ORDER A CRATE</h2>
      <h4>Normal business hour are between 8:30AM-15:30PM Mondays till Fridays and on Saturday’s between 8:00AM and 12:00(No orders or deliveries will be done on Public Holidays)</h4>
      <a href="https://www.google.com/maps/place/The+Scrub+Hare/@-22.5203634,17.0446693,15z/data=!4m2!3m1!1s0x0:0xdc2b25f2aefe54b3?sa=X&ved=2ahUKEwj3vICkn9bnAhWR5OAKHWg4ATYQ_BIwFHoECBcQBg" class="circle">
	<img height="128" width="128" src="https://drive.google.com/uc?export=view&id=123fyXEmXu8SS-WowjoRZcqf5nX__Bkv1" alt="!Oas" class="center">
</a>
      <p>Welcome to the official website of the Scrub Hare Crate Project this project is funded and endorsed by the Footloose Archives Namibian Travel Magazine Staff.
      <br />
      Thank you for being apart of this ever growing project and we look forward to bringing more products to this site in the future.
      </p>
    </div>

    <div :class="$style.teaser">
      <h2 :class="$style.headline">
        Products
      </h2>
      <ProductTeaserContainer/>
    </div>

    <div :class="$style.teaser">
      <h2 :class="$style.headline">
        Articles
      </h2>
      <ArticleTeaserContainer/>
    </div>
  </div>
</template>

<script>
import ArticleTeaserContainer from '../components/ArticleTeaserContainer.vue';
import ProductTeaserContainer from '../components/ProductTeaserContainer.vue';

export default {
  name: `PageHome`,
  components: {
    ArticleTeaserContainer,
    ProductTeaserContainer,
  },
};
</script>

<style lang="scss" module>
.intro {
  max-width: 32em;
  margin-right: auto;
  margin-left: auto;
  font-size: 1.25em;
  text-align: center;
}

.headline {
  margin-bottom: 0.5em;
  font-size: 1.75em;
  line-height: 1.2;
}

.teaser {
  margin-top: 3em;
}
</style>
